"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.FLEET_ENDPOINT = {
    getVehicleDetail: '/fleet/backoffice/vehicles/{{vehicleId}}',
    getVehicleOverview: '/fleet/backoffice/vehicles/{{vehicleId}}/overview',
    getVehicleCategories: '/fleet/backoffice/vehicles/categories?cs_operator_uuid={{csOperatorUuid}}',
    postVehicle: '/fleet/backoffice/vehicles',
};
